import axios from "axios";
import { getAPIUrl } from "../config";

const api = axios.create({
  baseURL: getAPIUrl(),
});

const addressService = {
  async getAddress(zipCode) {
    const token = localStorage.getItem("token");

    const response = await api.get(`/v1/addresses/${zipCode}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },
};

export default addressService;